import React from 'react';

import { Input } from '.';

/**
 * @typedef {{
 *  value: string,
 *  onChange: (value: string) => void,
 * } & import('antd/lib/input/Password').PasswordProps} PasswordNumberInputProps
 */

/** @type {React.FC<PasswordNumberInputProps>} */
const PasswordNumberInput = ({ value, onChange, ...props }) => {
  const handleChange = ({ target }) => {
    const { value: newValue } = target;
    if (newValue === '' || /^\d+$/.test(newValue)) {
      onChange(newValue);
    }
  };

  return <Input.Password {...props} value={value} onChange={handleChange} className="text-left" />;
};

export default PasswordNumberInput;
